import { toast } from 'react-toastify';

const extractFilenameFromContentDisposition = (
  header: string | null
): string => {
  if (!header) {
    return 'downloaded-file.pdf';
  }

  // Case 1: filename*=UTF-8''über%20den%20Wolken.pdf
  const utf8Match = header.match(/filename\*\s*=\s*UTF-8''([^;\n]*)/i);
  if (utf8Match && utf8Match[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      // console.warn('Fehler beim Dekodieren von UTF-8 Filename', e);
    }
  }

  // Case 2: filename="file.pdf" oder filename=file.pdf
  const asciiMatch = header.match(
    /filename\s*=\s*(?:["']?)([^"';\n]+)(?:["']?)/i
  );
  if (asciiMatch && asciiMatch[1]) {
    return asciiMatch[1];
  }

  return 'downloaded-file.pdf';
};

const triggerDownloadFlow = (
  urlToDownload: string,
  token: string | null,
  i18n: {
    loading: string;
    failed: string;
    success: string;
  }
) => {
  const toastId = toast(i18n.loading, {
    autoClose: false,
    isLoading: true,
    progress: 0,
    closeOnClick: false,
  });

  const xhr = new XMLHttpRequest();
  xhr.open('GET', urlToDownload, true);
  xhr.responseType = 'blob';
  xhr.setRequestHeader('Authorization', `Bearer ${token}`);

  const sudoToken = sessionStorage.getItem('sudoToken');
  if (sudoToken) {
    xhr.setRequestHeader('x-signing-verification-token', sudoToken);
  }

  xhr.onprogress = (event: ProgressEvent) => {
    if (event.lengthComputable) {
      toast.update(toastId, {
        progress: event.loaded / event.total,
        render: `${i18n.loading} ${Math.round(
          (event.loaded / event.total) * 100
        )}%`,
      });
    }
  };

  xhr.onload = () => {
    toast.update(toastId, {
      render: i18n.success,
      type: 'success',
      progress: 0,
      autoClose: 5000,
      isLoading: false,
      closeOnClick: true,
    });

    const url = URL.createObjectURL(xhr.response as Blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = extractFilenameFromContentDisposition(
      xhr.getResponseHeader('Content-Disposition')
    );
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  xhr.onerror = () => {
    toast.update(toastId, {
      render: i18n.failed,
      type: 'error',
      progress: 0,
      autoClose: 5000,
      isLoading: false,
      closeOnClick: true,
    });
  };

  xhr.send();
};

export default triggerDownloadFlow;
